import { IObject } from "@quest/base-core";
import { reelPanel, slot } from "@quest/slot-core";
import { BehaviorCoreModule } from "@quest/murka-games-behavior-panther/dist";

//  BASE GAME
import { BaseControllerGame } from "./Base/BaseControllerGame";
import { BaseGameViewGame } from "./Base/BaseGameViewGame";
import { MetersControllerGame } from "./Base/MetersControllerGame";
import { ButtonControllerGame } from "./Base/ButtonControllerGame";
import { ReelPanelControllerGame } from "./Base/ReelPanelControllerGame";
import { WinPresentationControllerGame } from "./Base/WinPresentationControllerGame";
import { BaseGameModel } from "./model/BaseGameModel";
import { GameClientLogic } from "./Logic/GameClientLogic";
import { gameConstants } from "./Constants/gameConstants";
import { SettingPanelController } from "./Base/SettingPanelController";
import { PostLoadingControllerGame } from "./PostLoading/PostLoadingControllerGame";
import { GameIntroControllerGame } from "./GameIntro/GameIntroControllerGame";

//  INTRO OUTRO
import { IntroOutroControllerGame } from "./IntroOutro/IntroOutroControllerGame";
import { IntroOutroViewGame } from "./IntroOutro/IntroOutroViewGame";

// BIG WIN
import { BigWinControllerFgGame } from "./BigWin/BigWinControllerFgGame";

// FREE GAME
import { FreeGameView } from "./FreeGame/FreeGameView";
import { FreeGameControllerGame } from "./FreeGame/FreeGameControllerGame";
import { FreeGameReelPanelControllerGame } from "./FreeGame/FreeGameReelPanelController";
import { BackgroundControllerGame } from "./Background/BackgroundControllerGame";
import { FreeGameWinPresentationControllerGame } from "./FreeGame/FreeGameWinPresentationControllerGame";
import { ReelGame } from "./ReelPanel/Reel";
import { FreeGameModel } from "./model/FreeGameModel";
import { SymbolBaseGame } from "./UI/SymbolBaseGame";
import { BigWinControllerGame } from "./BigWin/BigWinControllerGame";
import { BigWinViewGame } from "./BigWin/BigWinViewGame";
import { WinPresentationPanelGame } from "./ReelPanel/WinPresentationPanelGame";
import { BlurBackgroundControllerGame } from "./BlurBackground/BlurBackgroundController";
import { PlayerMsgControllerGame } from "./playermessage/PlayerMsgControllerGame";
import { FreeGameMetersControllerGame } from "./FreeGame/FreeGameMetersControllerGame";
import { TopLogoViewGame } from "./TopLogoView/TopLogoViewGame";
import { BackgroundViewGame } from "./Background/BackgroundViewGame";
import { TopLogoViewfgGame } from "./TopLogoView/TopLogoViewfgGame";
import { TopBarViewGame } from "./Topbar/TopBarViewGame";
import { TopLogoControllerFgGame } from "./TopLogoView/TopLogoControllerFgGame";
import { FreeGameButtonControllerGame } from "./FreeGame/FreeGameButtonControllerGame";
// This is only for adding coreModuleList in final game js else use gameConstants directly//
export let game: IObject = {
  gameConstants: gameConstants,
};

BehaviorCoreModule.GameIntroController = GameIntroControllerGame;
BehaviorCoreModule.FreeGameController = FreeGameControllerGame;
BehaviorCoreModule.FreeGameView = FreeGameView;
BehaviorCoreModule.PostLoadingController = PostLoadingControllerGame;
BehaviorCoreModule.BaseController = BaseControllerGame;
BehaviorCoreModule.BaseView = BaseGameViewGame;
BehaviorCoreModule.BigWinView = BigWinViewGame;
BehaviorCoreModule.IntroOutroController = IntroOutroControllerGame;
BehaviorCoreModule.IntroOutroView = IntroOutroViewGame;
BehaviorCoreModule.SettingPannelController = SettingPanelController;
BehaviorCoreModule.BigWinController = BigWinControllerGame;
BehaviorCoreModule.BigWinControllerFg = BigWinControllerFgGame;
BehaviorCoreModule.TopLogoView = TopLogoViewGame;
BehaviorCoreModule.TopBarView = TopBarViewGame;
BehaviorCoreModule.TopLogoViewFg = TopLogoViewfgGame;
BehaviorCoreModule.BackGroundView = BackgroundViewGame,
BehaviorCoreModule.TopLogoControllerFg = TopLogoControllerFgGame;
slot.SlotLogic = GameClientLogic;
slot.BaseWinPresentationController = WinPresentationControllerGame;
slot.BaseReelPanelController = ReelPanelControllerGame;
slot.BaseMetersController = MetersControllerGame;
BehaviorCoreModule.FreeGameMetersController = FreeGameMetersControllerGame;
slot.BaseButtonController = ButtonControllerGame;
BehaviorCoreModule.BlurBackgroundController = BlurBackgroundControllerGame;
BehaviorCoreModule.FreeGameReelPanelController = FreeGameReelPanelControllerGame;
BehaviorCoreModule.BaseModel = BaseGameModel;
BehaviorCoreModule.FreeGameModel = FreeGameModel;
BehaviorCoreModule.FreeGameButtonController = FreeGameButtonControllerGame;
reelPanel.SymbolBase = SymbolBaseGame;
BehaviorCoreModule.BackgroundController = BackgroundControllerGame;
BehaviorCoreModule.FreeGameWinPresentationController = FreeGameWinPresentationControllerGame;
reelPanel.Reel = ReelGame;
reelPanel.WinReelPanel = WinPresentationPanelGame;
BehaviorCoreModule.PlayerMsgController = PlayerMsgControllerGame;
